import React from 'react';

export const ExportButton = ({ onExport, disabled }) => {
    return (
        <button
            onClick={onExport}
            disabled={disabled}
            style={{
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                height: '44px', // Fixed height for consistency
                opacity: disabled ? 0.6 : 1
            }}
            title="Export to Word"
        >
            <span>📄</span> Export to Word
        </button>
    );
};

export const ResetButton = ({ onReset }) => {
    const handleClick = () => {
        if (window.confirm("All entered information will be lost. Do you want to continue?")) {
            onReset();
        }
    };

    return (
        <button
            onClick={handleClick}
            style={{
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                height: '44px' // Fixed height for consistency
            }}
            title="Reset form"
        >
            <span>🔄</span> Reset Form
        </button>
    );
};
